import { render, staticRenderFns } from "./AssessmentNew.vue?vue&type=template&id=1c0dfa66"
import script from "./AssessmentNew.vue?vue&type=script&lang=js"
export * from "./AssessmentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports